import { render, staticRenderFns } from "./BaseDateInput.vue?vue&type=template&id=39ae1f43&scoped=true&"
import script from "./BaseDateInput.vue?vue&type=script&lang=js&"
export * from "./BaseDateInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseDateInput.vue?vue&type=style&index=0&id=39ae1f43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ae1f43",
  null
  
)

export default component.exports